// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__2N1sp","aloqa":"Footer_aloqa__1R7_X","adres":"Footer_adres__3D3VE","soat":"Footer_soat__vfF_F","tel":"Footer_tel__2Me0c"};